import * as Yup from "yup";

export const schema = Yup.object()
  .typeError("Введите пароль")
  .shape({
    //passwordCurrent: Yup.string().required('Поле "Текущий пароль" обязательно для заполнения'),
    newPassword: Yup.string()
      .typeError("Введите пароль")
      .required('Поле "Пароль" обязательно для заполнения'),
    newPasswordRepeat: Yup.string()
      .typeError("Введите пароль")
      .test(
        "passwords-match",
        "Введенные пароли не совпадают",
        function (value) {
          return this.parent.newPassword === value;
        },
      ),
  });
